const BACKEND_URL = process.env.REACT_APP_API_BASE

// Optional asset base for frontend-built image URLs (`<base>/images/<name>`); unset falls back to `/static/images` (unchanged, additive).
const ASSET_BASE = (process.env.REACT_APP_ASSET_BASE || '').replace(/\/+$/, '')

export default function getBackendImage(imageName) {
    // The API may return a full URL for images. If so, use it as-is so we
    // don't double-prefix; otherwise treat it as a bare filename (legacy shape).
    if (!imageName) return imageName
    if (/^https?:\/\//i.test(imageName)) return imageName
    if (ASSET_BASE) return `${ASSET_BASE}/images/${imageName}`
    return `${BACKEND_URL}/static/images/${imageName}`
}

export const uploadImage = async (file) => {
    const formData = new FormData()
    formData.append("image", file)

    const res = await fetch(`${BACKEND_URL}/api/upload-image`, {
        method: "POST",
        body: formData
    })

    const data = await res.json()
    return data.filename
}
